// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"05cb6628","482":"ea6bfcba","497":"982a4e9f","580":"1792333f","620":"314bb1d2","797":"dcabde01","934":"feb7692c"}[chunkId] + ".chunk.js";
};